(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-slider"] && !Shopify.designMode) return;
  try {
    (() => {
    const ffSyncAutoplay = (block) => {
      const slider = block?.querySelector('ff-slider');
      const swiper = slider?.ffSwiper;
      if (!swiper?.autoplay) return;

      // The toggle is excluded so that pressing Play with focus on it resumes.
      const isPaused = block.hasAttribute('data-ff-paused-by-user') || slider.matches(':hover, :focus-within');
      if (isPaused && swiper.autoplay.running) swiper.autoplay.stop();
      if (!isPaused && !swiper.autoplay.running) swiper.autoplay.start();
    };

    const ffSetPausedByUser = (block, isPaused) => {
      const toggle = block.querySelector(':scope > [data-ff-autoplay-toggle]');
      block.toggleAttribute('data-ff-paused-by-user', isPaused);
      toggle?.setAttribute('aria-label', isPaused ? toggle.dataset.ffLabelPlay : toggle.dataset.ffLabelPause);
      ffSyncAutoplay(block);
    };

    const ffAutoplayBlock = (target) => {
      const block = target.closest?.('.ff-slider-block');
      return block?.querySelector('ff-slider')?.ffSwiper?.params.autoplay.enabled ? block : null;
    };

    customElements.whenDefined('ff-slider').then(() => {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      document.querySelectorAll('.ff-slider-block').forEach((block) => {
        if (ffAutoplayBlock(block)) ffSetPausedByUser(block, true);
      });
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-ff-autoplay-toggle]');
      if (!toggle) return;

      const block = toggle.closest('.ff-slider-block');
      ffSetPausedByUser(block, !block.hasAttribute('data-ff-paused-by-user'));
    });

    // :hover and :focus-within are not updated yet when the out events fire.
    ['mouseover', 'mouseout', 'focusin', 'focusout'].forEach((type) => {
      document.addEventListener(type, (event) => {
        const block = ffAutoplayBlock(event.target);
        if (block) requestAnimationFrame(() => ffSyncAutoplay(block));
      });
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('.swiper-slide');
      const slider = slide?.closest('ff-slider');
      if (!slider?.ffSwiper) return;

      const index = Number(slide.dataset.swiperSlideIndex ?? [...slide.parentElement.children].indexOf(slide));
      if (slider.ffSwiper.params.loop) {
        slider.ffSwiper.slideToLoop(index);
      } else {
        slider.ffSwiper.slideTo(index);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
